import React, { useState, useEffect } from 'react';
import styles from '../../styles/Dashboard/DocumentsVerification.module.css';
import CheckrLogo from '../../assets/checkr.png';
import PlaidLogo from '../../assets/Plaid.png';
import ExperianLogo from '../../assets/TransUnion.png';
import TenantConsentModals from './TenantConsentModals';

const API_BASE_URL = import.meta.env.VITE_API_URL;

const logos = {
  'Credit Score': ExperianLogo,
  'Background Check': CheckrLogo,
  'Proof of Income': PlaidLogo,
};

const DOCUMENT_STEPS = ['User Consent', 'Payment Made', 'Data Received', 'Data Reviewed'];

const DEFAULT_STATUSES = {
  ConsentProvided: false,
  PaymentMade: false,
  DataReceived: false,
  DataReviewed: false,
};

const DocumentsVerification = ({ tenantUserId }) => {
  const [documents, setDocuments] = useState([]);
  const [showConsentModal, setShowConsentModal] = useState(false);
  const [activeDocumentType, setActiveDocumentType] = useState('');

  const padDocuments = (data) => {
    const types = ['Credit Score', 'Background Check', 'Proof of Income'];
    return types.map(type => {
      const existing = data.find(d => d.DocumentType === type);
      return existing || {
        DocumentType: type,
        ...DEFAULT_STATUSES,
      };
    });
  };

  const fetchDocuments = () => {
    fetch(`${API_BASE_URL}/users/documents/${tenantUserId}`)
      .then(res => res.ok ? res.json() : [])
      .then(data => setDocuments(padDocuments(data)))
      .catch(err => {
        console.error("Fetch error:", err);
        setDocuments(padDocuments([]));
      });
  };

  useEffect(() => {
    fetchDocuments();
  }, [tenantUserId]);

  const handleConsentComplete = () => {
    fetchDocuments();
    setShowConsentModal(false);
  };


  return (
    <>
      <div className={styles.verificationContainer}>
        <h3>Documents & Verification</h3>

        {documents.map((item, idx) => {
          const statuses = item.ConsentProvided
			  ? [true, true, true, true] // All steps appear completed once consent is given
			  : [false, false, false, false]; // Waiting at consent stage if no consent


          return (
            <div key={idx} className={styles.verificationCard}>
              <div className={styles.cardHeader}>
                <span className={styles.cardTitle}>{item.DocumentType}</span>
                <img src={logos[item.DocumentType]} alt={item.DocumentType} className={styles.providerLogo} />
              </div>

              <div className={styles.progressContainer}>
                {DOCUMENT_STEPS.map((step, stepIdx) => (
                  <div key={stepIdx} className={styles.step}>
                    <div className={`${styles.circle} ${statuses[stepIdx] ? styles.completed : styles.pending}`}>
                      {statuses[stepIdx] ? '✔️' : '○'}
                    </div>
                    {stepIdx < DOCUMENT_STEPS.length - 1 && (
                      <div className={styles.connectorLine}></div>
                    )}
                    <div className={styles.stepLabel}>{step}</div>
                  </div>
                ))}
              </div>

              {!item.ConsentProvided && (
                <button
                  className={styles.actionBtn}
                  onClick={() => {
                    setActiveDocumentType(item.DocumentType);
                    setShowConsentModal(true);
                  }}
                >
                  Provide {item.DocumentType}
                </button>
              )}
            </div>
          );
        })}
      </div>

      {showConsentModal && (
        <TenantConsentModals
          tenantUserId={tenantUserId}
          documentType={activeDocumentType}
          closeModal={() => setShowConsentModal(false)}
          refreshDocuments={handleConsentComplete}
        />
      )}
    </>
  );
};

export default DocumentsVerification;
